export default {
  url: 'https://aol.alvaroapoio.com.br/exames',
  headers: {
    basicAuthentication: 'Basic ZGFzYS1jbGllbnQtaWQ6c2VjcmV0',
    basicAuthenticationForLocalHost: 'Basic YWRtaW46dGVzdGUxMjM=',
    bearerAuthentication: 'Bearer ',
    formUrlEncoded: 'application/x-www-form-urlencoded',
    formJSON: 'application/json',
  },
  login: {
    'missing-lab': {
      message: 'Preencha todos os campos para entrar.',
      type: 'error',
    },
    'missing-username': {
      message: 'Preencha todos os campos para entrar.',
      type: 'error',
    },
    'missing-password': {
      message: 'Preencha todos os campos para entrar.',
      type: 'error',
    },
    'login-missing-both': {
      message: 'Preencha todos os campos para entrar.',
      type: 'error',
    },
    'server-fail': {
      message: 'Erro ao realizar requisição. Por favor, tente novamente mais tarde.',
      type: 'error',
    },
    'login-fail': {
      message: 'Usuário ou senha inválido(s).',
      type: 'error',
    },
    'login-block': {
      message:
        'Usuário bloqueado por exceder as tentativas de acesso. Por favor, entre em contato com o nosso suporte.',
      type: 'error',
    },
    'upload-wrong-type': {
      message: 'Formato de arquivo inválido.',
      type: 'error',
    },
  },
  orderStatus: {
    E: {
      status: 'ERROR',
      translated: 'INCORRETA',
    },
    F: {
      status: 'FIXED',
      translated: 'CORRIGIDA',
    },
    C: {
      status: 'CORRECT',
      translated: 'CORRETA',
    },
  },
  recollectStatus: {
    PENDENTE: {
      name: 'Pendente',
      buttonLabel: 'Recoletar',
      buttonStyle: 'btn-primary-red',
      action: 'createNewOrder',
    },
    OS_CRIADA: {
      name: 'Aguardando Transferência',
      buttonLabel: 'Ver cadastro',
      buttonStyle: 'btn-secondary-orange',
      action: 'showOrder',
    },
    REALIZADO: {
      name: 'Realizado',
      buttonLabel: 'Ver amostra',
      buttonStyle: 'btn-secondary',
      action: 'showSample',
    },
  },
  limitDaysForCalendar: {
    batches: 10,
    orders: 20,
    samples: 20,
    traceability: 7,
  },
  sampleStatus: {
    true: 'Impresso',
    false: 'Não Impresso',
  },
  genders: [
    // {value: null, label: 'Selecione o sexo', $isDisabled: true},
    {
      value: 'F',
      label: 'Feminino',
    },
    {
      value: 'M',
      label: 'Masculino',
    },
  ],
  brazilStates: [
    {
      value: null,
      label: 'Selecione UF',
      $isDisabled: true,
    },
    {
      value: 'AC',
      label: 'AC',
    },
    {
      value: 'AL',
      label: 'AL',
    },
    {
      value: 'AM',
      label: 'AM',
    },
    {
      value: 'AP',
      label: 'AP',
    },
    {
      value: 'BA',
      label: 'BA',
    },
    {
      value: 'CE',
      label: 'CE',
    },
    {
      value: 'DF',
      label: 'DF',
    },
    {
      value: 'ES',
      label: 'ES',
    },
    {
      value: 'GO',
      label: 'GO',
    },
    {
      value: 'MA',
      label: 'MA',
    },
    {
      value: 'MG',
      label: 'MG',
    },
    {
      value: 'MS',
      label: 'MS',
    },
    {
      value: 'MT',
      label: 'MT',
    },
    {
      value: 'PA',
      label: 'PA',
    },
    {
      value: 'PB',
      label: 'PB',
    },
    {
      value: 'PE',
      label: 'PE',
    },
    {
      value: 'PI',
      label: 'PI',
    },
    {
      value: 'PR',
      label: 'PR',
    },
    {
      value: 'RJ',
      label: 'RJ',
    },
    {
      value: 'RN',
      label: 'RN',
    },
    {
      value: 'RO',
      label: 'RO',
    },
    {
      value: 'RR',
      label: 'RR',
    },
    {
      value: 'RS',
      label: 'RS',
    },
    {
      value: 'SC',
      label: 'SC',
    },
    {
      value: 'SE',
      label: 'SE',
    },
    {
      value: 'SP',
      label: 'SP',
    },
    {
      value: 'TO',
      label: 'TO',
    },
  ],
  additionalFieldTypeMask: {
    DECIMAL: 'decimal',
    INTEGER: 'numeric',
    TEXT: 'regex:^[\\w\\-\\.\\@\\_]*$',
  },
  additionalFieldTypeToValidation: {
    DECIMAL: 'decimal',
    INTEGER: 'numeric',
    TEXT: 'text',
  },
  exported: {
    true: 'Sim',
    false: 'Não',
  },
  filter: [
    {
      value: 'OSID',
      label: 'Data do Cadastro',
    },
    {
      value: 'PATIENT',
      label: 'Paciente',
    },
    {
      value: 'OSLIS',
      label: 'OS Lis',
    },
    {
      value: 'GENERATEDAT',
      label: 'Geração da amostra',
    },
    {
      value: 'MATERIALPACKAGING',
      label: 'Acondicionamento',
    },
  ],
  samplesOrderBy: [
    {
      value: null,
      label: 'Selecione um campo',
    },
    {
      value: 'GENERATEDAT',
      label: 'Geração da amostra',
    },
    {
      value: 'MATERIALPACKAGING',
      label: 'Acondicionamento',
    },
    {
      value: 'OSID',
      label: 'Data do Cadastro',
    },
    {
      value: 'OSLIS',
      label: 'OS Lis',
    },
    {
      value: 'PATIENT',
      label: 'Paciente',
    },
  ],
  resultsFilter: [
    {
      value: '',
      label: 'Todos',
    },
    {
      value: 'true',
      label: 'Exportados',
    },
    {
      value: 'false',
      label: 'Não Exportados',
    },
  ],
  originResultsFilter: [
    {
      value: '',
      label: 'Todos',
    },
    {
      value: 'true',
      label: 'Cadastradas via Importação',
    },
    {
      value: 'false',
      label: 'Cadastrados Manualmente',
    },
  ],
  printedFilter: [
    {
      value: '',
      label: 'Todos',
    },
    {
      value: 'true',
      label: 'Impressas',
    },
    {
      value: 'false',
      label: 'Não Impressas',
    },
  ],
  dateType: [
    {
      value: 'TD',
      label: 'data de cadastro no AOL',
    },
    {
      value: 'RD',
      label: 'data do resultado',
    },
  ],
  filterBatch: [
    {
      value: 'OPEN',
      label: 'Aberto',
    },
    {
      value: 'CLOSED',
      label: 'Fechado',
    },
    {
      value: 'PENDING_TRANSMIT',
      label: 'Em transferência',
    },
    {
      value: 'TRANSMITTED',
      label: 'Transmitido',
    },
    {
      value: 'PRINTED',
      label: 'Impresso',
    },
  ],
  batchStates: {
    OPENNED: {
      state: 'opened',
      translatedState: 'Aberto',
    },
    CLOSED: {
      state: 'closed',
      translatedState: 'Completo',
    },
  },
  additionalInformationStatus: [
    {
      id: 1,
      name: 'Lote Urgente',
      state: 'urgent-fast',
      color: 'background-color-yellow',
      type: 'urgent',
    },
  ],
  packagingStatus: [
    {
      name: 'Congelado',
      state: 'frozen',
      type: 'C',
      id: 25,
      active: true,
      color: 'background-color-malibu',
    },
    {
      name: 'Refrigerado',
      state: 'refrigerated',
      id: 26,
      type: 'R',
      active: true,
      color: 'background-color-royal-blue',
    },
    {
      name: 'Ambiente',
      state: 'room-temperature',
      id: 27,
      type: 'A',
      active: true,
      color: 'background-color-jaffa',
    },
    {
      name: 'Refrigerado Seco',
      state: 'refrigerated-dry',
      type: 'S',
      id: 208,
      active: true,
      color: 'background-color-shakespeare',
    },
    {
      name: 'Outros',
      state: 'generate-list',
      id: 101,
      type: 'V',
      active: false,
      color: 'background-color-darken-gray',
    },
    {
      name: 'Outros',
      state: 'generate-list',
      id: 205,
      type: 'V',
      active: false,
      color: 'background-color-darken-gray',
    },
    {
      name: 'Outros',
      state: 'generate-list',
      id: 206,
      type: 'V',
      active: false,
      color: 'background-color-darken-gray',
    },
    {
      name: 'Outros',
      state: 'generate-list',
      id: 207,
      type: 'V',
      active: false,
      color: 'background-color-darken-gray',
    },
  ],
  batchHelpSteps: [
    'Transmitir amostras',
    'Imprimir etiquetas',
    'Agrupar lotes',
    'Colar etiquetas',
    'Despachar lotes',
  ],
  filterOS: [
    {
      value: 'ERROR',
      label: 'com erro',
      labelVisible: true,
    },
    {
      value: 'FIXED',
      label: 'corrigidas',
      labelVisible: true,
    },
    {
      value: 'CORRECT',
      label: 'corretas',
      labelVisible: true,
    },
    {
      value: 'T',
      label: 'transferidas',
      labelVisible: true,
    },
    {
      value: 'P',
      label: 'não transferidas',
      labelVisible: true,
    },
    {
      value: 'F',
      label: 'com falhas',
      labelVisible: false,
    },
  ],
  notificationTypes: [
    {
      value: 'F',
      label: 'Financeiro',
      icon: 'finance',
    },
    {
      value: 'M',
      label: 'Marketing',
      icon: 'marketing',
    },
    {
      value: 'P',
      label: 'Mensagens da Produção',
      icon: 'prod',
    },
    {
      value: 'N',
      label: 'NAC/UTR/NAM',
      icon: 'nac',
    },
    {
      value: 'O',
      label: 'Operação AOL - Atualizações',
      icon: 'operations',
    },
    {
      value: 'U',
      label: 'Urgente',
      icon: 'prod',
    },
  ],
  orderStates: {
    R: {
      state: 'RECEIVED',
      translatedState: 'Recebido',
      buttonText: 'Recebido',
      buttonIcon: '/static/images/icon-send-gray.svg',
      statusPendig: 'R',
    },
    V: {
      state: 'VALIDATED',
      translatedState: 'Validado',
      buttonText: 'Transferir',
      buttonIcon: '/static/images/icon-send.svg',
      statusPendig: 'V',
    },
    T: {
      state: 'TRANSMITTED',
      translatedState: 'Transferido',
      buttonText: 'Transferido',
      buttonIcon: '/static/images/icon-send-gray.svg',
      statusPendig: 'T',
    },
    P: {
      state: 'TRANSFERRING',
      translatedState: 'Pendente Transferência',
      buttonText: 'Transferindo',
      buttonIcon: '/static/images/icon-send-yellow.svg',
      statusPendig: 'P',
    },
    N: {
      state: 'PENDING-TRANSMISSION',
      translatedState: 'Pendente Transferência',
      buttonText: 'Transferir',
      buttonIcon: '/static/images/icon-send.svg',
      statusPendig: 'N',
    },
    F: {
      state: 'FAILED',
      translatedState: 'Pendente Transferência',
      buttonText: 'Falha',
      buttonIcon: '/static/images/icon-send.svg',
      statusPendig: 'F',
    },
  },
  traceabilityStatus: {
    CADASTRADO: {
      state: 'WAITING_TRANSPORT',
      symbolColor: 'text-color-green-light',
      color: '#76d692',
      progressPercent: '12%',
      translated: 'Cadastrado',
      detailsText: 'Gerado dia',
      glossary:
        'A amostra foi gerada e o lote está pronto para ser retirado pela nossa logística.',
    },
    AMOSTRA_OBTIDA: {
      state: 'WAITING_TRANSPORT',
      symbolColor: 'text-color-green-light',
      color: '#76d692',
      progressPercent: '12%',
      translated: 'Amostra registrada',
      detailsText: 'Gerado dia',
      glossary: 'A amostra foi cadastrada sistemicamente no ambiente de producao.',
    },
    EM_TRANSITO: {
      state: 'COLLECTED',
      symbolColor: 'text-color-green-light',
      color: '#76d692',
      progressPercent: '30%',
      translated: 'Em trânsito',
      detailsText: 'Coletado dia',
      glossary: 'O lote está em trânsito, a caminho do nosso NTO.',
    },
    TRIAGEM: {
      state: 'DELIVERED',
      symbolColor: 'text-color-green-light',
      color: '#76d692',
      progressPercent: '50%',
      translated:
        'Lote entregue no setor de Triagem do NTO, aguarda análise e recebimento sistêmico',
      detailsText: 'Entregue dia',
      glossary:
        'Lote entregue ao NTO. Aguardando recebimento das amostras na área técnica.',
    },
    EM_EXECUCAO: {
      state: 'AT_EXECUTION',
      symbolColor: 'text-color-green-light',
      color: '#76d692',
      progressPercent: '70%',
      translated: 'Em execução',
      detailsText: 'Iniciado dia',
      glossary: 'O exame entrou em execução.',
    },
    EM_LIBERACAO: {
      state: 'WAITING_LIBERATION',
      symbolColor: 'text-color-green-light',
      color: '#76d692',
      progressPercent: '88%',
      translated: 'Aguardando Liberação',
      detailsText: 'Exame executado aguardando liberação -',
      glossary: 'O exame foi executado e está aguardando liberação técnica.',
    },
    FINALIZADO: {
      state: 'FINALIZED',
      symbolColor: 'text-color-green-dark',
      color: '#32a454',
      progressPercent: '100%',
      translated: 'Laudo liberado',
      detailsText: 'Liberado dia',
      glossary: 'O exame foi executado e seu resultado está disponível.',
    },
    LAUDO_LIBERADO: {
      state: 'FINALIZED',
      symbolColor: 'text-color-green-dark',
      color: '#32a454',
      progressPercent: '100%',
      translated: 'Laudo liberado',
      detailsText: 'Liberado dia',
      glossary: 'O exame foi executado e seu resultado está disponível.',
    },
    EM_TRANSITO_ENTRE_NTO: {
      state: 'COLLECTED',
      symbolColor: 'text-color-yellow-dark',
      color: '#f5a623',
      progressPercent: '30%',
      translated: 'Em trânsito entre NTOs',
      detailsText: 'Coletado dia',
      glossary:
        'A amostra foi transferida para execução em outro NTO, e nesse momento encontra-se em trânsito',
    },
    ATRASADO: {
      state: 'DELAYED',
      symbolColor: 'text-color-yellow-dark',
      color: '#f5a623',
      progressPercent: '50%',
      translated: 'Atrasado',
      detailsText: 'Aguardando Liberação',
      glossary: 'O exame está na fila para ser executado.',
    },
    /* STATUS NAO_RECEBIDA TO BE REMOVED - FOI SUBSTITUIDO POR NAO_LOTEADA_FISICAMENTE */
    NAO_RECEBIDA: {
      state: 'NOT_RECEIVED',
      symbolColor: 'text-color-wine',
      color: '#87003f',
      translated: 'Amostra não localizada no Lote',
      progressPercent: '50%',
      detailsText: 'Amostra não encontrada no Lote enviado -',
    },
    NAO_LOTEADA_FISICAMENTE: {
      state: 'NOT_RECEIVED',
      symbolColor: 'text-color-wine',
      color: '#87003f',
      progressPercent: '50%',
      translated: 'Amostra não localizada no Lote',
      detailsText: 'Amostra não encontrada no Lote enviado -',
      glossary: 'O lote chegou ao NTO, mas a amostra não constava fisicamente no mesmo.',
    },
    /* STATUS NAO_ENVIADA TO BE REMOVED - FOI SUBSTITUIDO POR RETIRADA_EXPIRADA */
    NAO_ENVIADA: {
      state: 'NOT_SENT',
      symbolColor: 'text-color-wine',
      color: '#87003f',
      progressPercent: '12%',
      translated: 'Não enviada',
      detailsText: 'Amostra/Lote não entregue para a logística -',
    },
    RETIRADA_EXPIRADA: {
      state: 'NOT_SENT',
      symbolColor: 'text-color-wine',
      color: '#87003f',
      progressPercent: '12%',
      translated: 'Não enviada',
      detailsText: 'Amostra/Lote não entregue para a logística -',
      glossary: 'A amostra não foi retirada ou entregue para a logística.',
    },
    NAO_RASTREADO: {
      state: 'NOT_TRACKED',
      symbolColor: 'text-color-wine',
      color: '#87003f',
      progressPercent: '30%',
      translated: 'Não rastreada',
      detailsText: 'Amostra/Lote retirado mas não entregue no NTO -',
      glossary: 'Após retirada do lote, não recebemos novos status logísticos.',
    },
    CANCELADO: {
      state: 'CANCELED',
      symbolColor: 'text-color-gray',
      color: '#919191',
      progressPercent: '100%',
      translated: 'Cancelado',
      detailsText: 'Cancelado -',
      glossary: 'Amostra cancelada pela unidade de produção.',
    },
    RECONVOCADO: {
      state: 'RECALLED',
      symbolColor: 'text-color-yellow-dark',
      color: '#f5a623',
      progressPercent: '100%',
      translated: 'Recoleta solicitada',
      detailsText: 'Necessário uma nova coleta -',
      glossary: 'Solicitada uma nova coleta.',
    },
    AMOSTRA_DESCARTADA: {
      state: 'DISCARDED_SAMPLE',
      symbolColor: 'text-color-gray',
      color: '#919191',
      progressPercent: '100%',
      translated: 'Amostra descartada',
      detailsText: 'Amostra descartada',
      glossary:
        'Amostra descartada pela unidade de produção após finalização do tempo de armazenamento.',
    },
    UNDEFINED_STATUS: {
      state: 'DELIVERED',
      symbolColor: 'text-color-buttercup',
      translated: 'Triagem',
      detailsText: 'Entregue dia',
    },
    PENDENCIA_CRIADA: {
      state: 'PENDENCY_CREATED',
      symbolColor: 'text-color-yellow-dark',
      color: '#f5a623',
      progressPercent: '50%',
      translated: 'Pendência criada',
      detailsText: 'Pendência criada',
      glossary: 'A pendência foi criada e está aguardando resposta.',
    },
    PENDENCIA_RESPONDIDA: {
      state: 'PENDENCY_RESPONDED',
      symbolColor: 'text-color-green-light',
      color: '#76d692',
      progressPercent: '100%',
      translated: 'Pendência respondida',
      detailsText: 'Pendência respondida',
      glossary: 'A pendência foi respondida.',
    },
    CANCELADO_CLIENTE: {
      state: 'CANCELED_BY_CLIENT',
      symbolColor: 'text-color-gray',
      color: '#919191',
      progressPercent: '100%',
      translated: 'Cancelado',
      detailsText: 'Cancelado',
      glossary: 'O exame foi cancelado pela integração.',
    },
    AGUARDANDO_RETIRADA: {
      state: 'WAITING_PICKUP',
      symbolColor: 'text-color-blue',
      color: '#2196F3',
      progressPercent: '5%',
      translated: 'Aguardando Retirada',
      detailsText: 'Aguardando retirada',
      glossary: 'A amostra está aguardando retirada pela logística.',
    },
    COM_PENDENCIA: {
      state: 'WITH_PENDENCY',
      symbolColor: 'text-color-orange',
      color: '#FF9800',
      progressPercent: '60%',
      translated: 'Com Pendência',
      detailsText: 'Pendência criada',
      glossary: 'O exame possui pendência que precisa ser resolvida.',
    },
    RECOLETADO: {
      state: 'RECOLLECTED',
      symbolColor: 'text-color-indigo',
      color: '#3F51B5',
      progressPercent: '100%',
      translated: 'Recoletado',
      detailsText: 'Recoletado',
      glossary: 'Uma nova coleta foi realizada para este exame.',
    },
    REMARCADO: {
      state: 'RESCHEDULED',
      symbolColor: 'text-color-cyan',
      color: '#00BCD4',
      progressPercent: '75%',
      translated: 'Remarcado',
      detailsText: 'Prazo remarcado',
      glossary: 'O prazo de entrega do exame foi remarcado.',
    },
    LAUDO_VISUALIZADO: {
      state: 'REPORT_VIEWED',
      symbolColor: 'text-color-green-dark',
      color: '#32a454',
      progressPercent: '100%',
      translated: 'Laudo Visualizado',
      detailsText: 'Laudo visualizado',
      glossary: 'O laudo foi visualizado pelo cliente.',
    },
  },
  traceabilitySearchType: {
    OS: {
      translated: 'OS do seu Lab',
    },
    OA: {
      translated: 'OS Alvaro',
    },
    PN: {
      translated: 'Paciente',
    },
    DT: {
      translated: 'Data',
    },
    ST: {
      translated: 'Status',
    },
    OL: {
      translated: 'OS Lis',
    },
    BA: {
      translated: 'Lote',
    },
  },
  pendenciesStatus: {
    P: {
      state: 'pending',
      name: 'Pendentes',
      message: 'Responder pendência',
      btnLabel: 'Responder',
      color: 'orange',
      icon: 'icon-file-replace-outline.svg',
    },
    R: {
      state: 'replied',
      name: 'Respondidas',
      message: 'Respondida',
      btnLabel: 'Exibir resposta',
      color: 'green',
      icon: 'icon-message-check-outline.svg',
    },
    C: {
      state: 'canceled',
      name: 'Canceladas',
      message: 'Cancelada',
      btnLabel: 'Expirada',
      color: 'red',
      icon: 'icon-cancelled.svg',
    },
  },
  pendenciesSearchType: {
    OL: {
      translated: 'OS do seu Lab',
    },
    OA: {
      translated: 'OS Alvaro',
    },
    PN: {
      translated: 'Paciente',
    },
  },
  idPlaceExecution: {
    1: {
      name: 'NTO-Cascavel',
    },
    2: {
      name: 'NTO-Jurua',
    },
    3: {
      name: 'NTO-Caxias',
    },
    4: {
      name: 'Patologia-NTO-Jurua',
    },
    5: {
      name: 'NTO-Caxias Motion',
    },
    6: {
      name: 'NTO-Curitiba',
    },
    7: {
      name: 'NTO-Cascavel II',
    },
    8: {
      name: 'DASA',
    },
    9: {
      name: 'NTO-Caxias Patologia',
    },
    10: {
      name: 'DASA',
    },
    11: {
      name: 'NTO-Cascavel II B',
    },
    12: {
      name: 'NTO-Alpha B',
    },
    13: {
      name: 'NTO-Jurua B',
    },
    14: {
      name: 'NTO-Alpha VIT',
    },
    15: {
      name: 'NTO-Cascavel VIT',
    },
    16: {
      name: 'NTO-Alpha Hap1',
    },
    17: {
      name: 'NTO-Alpha Hap2',
    },
    18: {
      name: 'DASA',
    },
    19: {
      name: 'NTO-I (IFI)',
    },
    20: {
      name: 'NTO-Recife',
    },
    21: {
      name: 'DASA',
    },
    22: {
      name: 'NTO-Valeclin',
    },
    23: {
      name: 'NTO-Alpha C (Desativado)',
    },
    24: {
      name: 'NTO-LSF',
    },
    25: {
      name: 'DASA',
    },
    26: {
      name: 'NTO-Insitus',
    },
    27: {
      name: 'NTO-Alpha C',
    },
    28: {
      name: 'Álvaro Patologia - Citoclin',
    },
    29: {
      name: 'Álvaro Patologia - Lida',
    },
    30: {
      name: 'Álvaro Patologia - Diagnose',
    },
    31: {
      name: 'NTO-DASA',
    },
    32: {
      name: 'NTO-Mogi das Cruzes',
    },
    33: {
      name: 'NTO-Brasilia',
    },
    34: {
      name: 'NTO-Cientifica',
    },
    35: {
      name: 'NTO-Alpha',
    },
  },
  filterState: ['T', 'P', 'F'], // T = TRANSMITTED | P = PENDING_TRANSMIT | F = FAIL
  participantsRelationship: [
    {
      value: 'C',
      label: 'Filho',
      gender: null,
      $isDisabled: true,
    },
    {
      value: 'M',
      label: 'Mãe',
      gender: 'F',
      $isDisabled: true,
    },
    {
      value: 'SF',
      label: 'Suposto pai',
      gender: 'M',
    },
    {
      value: 'SM',
      label: 'Suposta mãe',
      gender: 'F',
    },
  ],
  searchAddExamMessages: {
    insertPaternityInNotEmptyOS: {
      title: 'AVISO:',
      message: 'O exame de paternidade deve ser único em uma ordem de serviço.',
    },
    insertPaternityOnProfile: {
      title: 'AVISO:',
      message: 'O exame de paternidade não deve ser incluído em um perfil de exames.',
    },
    hasAlreadyPaternity: {
      title: 'AVISO:',
      message:
        'Ordem de serviço que já contém um exame de paternidade não pode receber novos exames.',
    },
    examDuplicatedNotAllowed: {
      title: 'AVISO:',
      message:
        'Este exame já existe nesta OS. Não é permitido acrescentar exames iguais em uma mesma ordem de serviço.',
    },
  },
  adminFeature: [
    {
      value: 'feature.nonSegregatedBatchList',
      label: 'Lista de lotes não segregados entre AOL e LIS'
    },
    {
      value: 'feature.toggleManage',
      label: 'Administração de Funcionalidades',
    },
    {
      value: 'feature.feedback',
      label: 'Feedback',
    },
    {
      value: 'feature.results',
      label: 'Resultado XML',
    },
    {
      value: 'feature.exam_urgent',
      label: 'Email - Material Nobre / Urgente',
    },
    {
      value: 'feature.spinner',
      label: 'Transferência de OS via Spinner',
    },
    {
      value: 'feature.notification_view',
      label: 'Central de Avisos - Visualização',
    },
    {
      value: 'feature.notification_edit',
      label: 'Central de Avisos - Edição',
    },
    {
      value: 'feature.exam_exclusion',
      label: 'Manutenção de OS - Exclusão',
    },
    {
      value: 'feature.exam_inclusion',
      label: 'Manutenção de OS - Inclusão',
    },
    {
      value: 'feature.printserverV1',
      label: 'Client de Impressão - Ativar V1',
    },
    {
      value: 'feature.printserverV2',
      label: 'Client de Impressão - Ativar V2',
    },
    {
      value: 'feature.printserverV3',
      label: 'Client de Impressão - Ativar V3',
    },
    {
      value: 'feature.printserverV4',
      label: 'Client de Impressão - Ativar V4',
    },
    {
      value: 'feature.examListLink',
      label: 'Lista de Exames',
    },
    {
      value: 'feature.billetLink',
      label: 'Boletos e Notas Fiscais',
    },
    {
      value: 'feature.traceability',
      label: 'Rastreabilidade'
    },
    {
      value: 'feature.prePaid',
      label: 'Pré Pago',
    },
    {
      value: 'feature.isLimitedPost',
      label: 'Pós Limitado'
    },
    {
      value: 'feature.documentsLink',
      label: 'Documentos',
    },
    {
      value: 'feature.priceListLink',
      label: 'Lista de Preços',
    },
    {
      value: 'feature.deepwater',
      label: 'Link para Deep Water',
    },
    {
      value: 'feature.responsibleSignature',
      label: 'Assinatura do médico no XML',
    },
    {
      value: 'feature.mergeAfterTransferred',
      label: 'Mergiar OS após transferida (XML)',
    },
    {
      value: 'feature.examDocument',
      label: 'Tela de Associação de Documentos a Exames',
    },
    {
      value: 'feature.userExamDocument',
      label: 'Funcionalidade que permite ao usuário cadastrar documentos',
    },
    {
      value: 'feature.bloodCount',
      label: 'Valores de referência do hemograma',
    },
    {
      value: 'feature.sortByFile',
      label: 'Ordernar amostras pelo ordem do XML',
    },
    {
      value: 'feature.collectDate',
      label: 'Exibir data de coleta no XML de resultado',
    },
    {
      value: 'feature.pendenciesManagement',
      label: 'Gestão de Pendências',
    },
    {
      value: 'feature.recollect',
      label: 'Recoletas',
    },
    {
      value: 'feature.collectPlace',
      label: 'Posto de Coleta',
    },
    {
      value: 'feature.covax',
      label:
        'Covaxx - Alterar rótulo dos campos DE: OS Lis - PARA: Requisition Number e desabilitar funcionalidades',
    },
    {
      value: 'feature.integrationAOLWs',
      label:
        'Exibir uma aba na tela “listagem de OS” dedicada a consulta de OSs geradas via AOLWS',
    },
    {
      value: 'feature.reportGenerator',
      label: 'Gerar relatórios',
    },
    {
      value: 'feature.microbiologyReport',
      label: 'Relatórios de Microbiologia',
    },
    {
      value: 'feature.fileImport',
      label: 'Importar arquivo',
    },
    {
      value: 'feature.profileExam',
      label: 'Gerenciar perfil de exames',
    },
    {
      value: 'feature.patientManagement',
      label: 'Gerenciar pacientes',
    },
    {
      value: 'feature.patientView',
      label: 'Ver amostras agrupado por paciente',
    },
    {
      value: 'feature.supplyManagement',
      label: 'Gestão de pedidos de insumos',
    },
    {
      value: 'feature.genera',
      label: 'Genera',
    },
    {
      value: 'feature.consentForm',
      label: 'Formulário de consentimento',
    },
    {
      value: 'feature.biometricData',
      label: 'Dados Biometricos',
    },
    {
      value: 'feature.webPrinting',
      label: 'Funcionalidade que permite a impressão web de etiquetas',
    },
    {
      value: 'feature.recollectReport',
      label: 'Gestão de recoletas',
    },
    {
      value: 'feature.pendingSamplesReport',
      label: 'Relatório de Amostras pendentes',
    },
    {
      value: 'feature.rescheduledReport',
      label: 'Gestão de remarcação',
    },
    {
      value: 'feature.helpCenterTutorial',
      label: 'Tutorial da Central de Ajuda',
    },
    {
      value: 'feature.generalData',
      label: 'Dados Gerais',
    },
    {
      value: 'feature.rollbacklaudasa',
      label: 'Clientes laudos laudasa',
    },
    {
      value: 'feature.printerPlugin',
      label: 'Habilita Plugin de Impressão',
    },
  ],
  adminFeatureOptions: [
    {
      value: true,
      label: 'Ativar',
    },
    {
      value: false,
      label: 'Desativar',
    },
  ],
  sortPrintBatches: [
    {
      value: 'os_lis',
      label: 'OS Lis',
    },
    {
      value: 'patient_name',
      label: 'Nome do Paciente',
    },
    {
      value: 'material_description',
      label: 'Material',
    },
    {
      value: 'number_alvaro_order',
      label: 'OS Álvaro',
    },
  ],
  listsLimits: {
    orders: 1000,
    samples: 1000,
    batches: 1000,
    results: 200,
    recollect: 20,
    pendencies: 20,
    panicAlerts: 200,
  },
  alertsStates: {
    true: {
      text: 'Habilitado',
    },
    false: {
      text: 'Desabilitado',
    },
  },
  iconModals: {
    attention: '/static/images/icon-alert-modal.svg',
    success: '/static/images/icon-correct-success.svg',
    traceabilityMapModal: '/static/images/icon-traceability-in-transit.svg',
    back: '/static/images/icon-turn-back.svg',
    impress: '/static/images/icon-impress.svg',
  },
  // Passos do Tour Guide
  '/dashboard': [
    {
      target: '.product-name',
      content: `Bem-vindo ao <strong>AOL 2.0</strong>!<br>Faça um tour pelo sistema.`,
      params: {
        placement: 'top',
      },
    },
    {
      target: '#btnDashboardRegister',
      content: 'Cadastre manualmente suas Ordens de Serviço',
      params: {
        placement: 'top',
      },
    },
    {
      target: '#btnDashboardUpload',
      content: 'Importe arquivos XML com exames',
      params: {
        placement: 'top',
      },
    },
    {
      target: '#orderMaintenance',
      content: 'Altere exames de uma amostra que já foi transferida',
      params: {
        placement: 'top',
      },
    },
    {
      target: '#btnDashboardResults',
      content: 'Encontre aqui os resultados e exporte-os no formato XML',
      params: {
        placement: 'top',
      },
    },
    {
      target: '#btnDashboardResultsExternal',
      content: 'Acesse a nossa plataforma de resultados e baixe-os em formato PDF',
    },
  ],
  '/orders': [
    {
      target: '#btnPrintTagFilter span#titleOrder',
      content: `Nesta tela listamos as <strong>Ordens de Serviços</strong> previamente cadastradas e importadas`,
    },
    {
      target: '#BtnOrdersNew',
      content: 'Aqui você pode cadastrar uma nova Ordem de Serviço.  ',
    },
    {
      target: '#BtnOrdersSend',
      content: 'Aqui você transfere todas as Ordens de Serviço listadas na tela.',
    },
    {
      target: '#backToSearch',
      content: 'Aqui você pode alterar os filtros selecionados. ',
    },
  ],
  '/samples': [
    {
      target: '#btnPrintTagFilter span#titleSample',
      content: `Nesta tela listamos as <strong>Amostras</strong> geradas`,
    },
    {
      target: '#btnPrintSamplesLabel',
      content: 'Aqui você pode imprimir os recibos selecionados na tela.',
    },
    {
      target: '#btnPrintBatchLabel',
      content: 'Aqui você pode imprimir as etiquetas das amostras selecionadas na tela.',
    },
    {
      target: '#backToSamplesSearch',
      content: 'Aqui você pode alterar os filtros selecionados.',
    },
  ],
  '/batches': [
    {
      target: '.subheader__content div',
      content: `Nesta tela você visualiza, seleciona, fecha e imprime as etiquetas de lotes`,
    },
    {
      target: '#sortFilter',
      content: 'Filtre os lotes por status',
    },
    {
      target: '#inputSearchBar',
      content: 'Faça a busca e encontre o lote desejado',
    },
    {
      target: '#datePickerSelect',
      content: 'Selecione um período para exibir os lotes criados nesse intervalo',
    },
    {
      target: '#btnCloseAndTransmit',
      content: 'Feche e transmita o lote',
    },
    {
      target: '#btnPrintBatch',
      content: 'Imprima as etiquetas dos lotes',
    },
  ],
  '/results': [
    {
      target: '.subheader__content div',
      content: `Aqui você lista e gera o XML dos laudos disponíveis para importação no seu Sistema`,
    },
    {
      target: '#filterTab',
      content:
        'Escolha quais resultados deseja listar com a ajuda dos filtros abaixo, liste e gere o XML de resultados',
    },
    {
      target: '#consultTab',
      content: 'Pesquise pelo resultado de um paciente específico',
    },
    {
      target: '#listResults',
      content:
        'Após aplicar os filtros desejados, clique aqui para exibir a listagem de resultados',
    },
    {
      target: '#getXmlResults',
      content: 'Ou clique aqui para fazer o download direto do XML',
    },
  ],
  '/results-list': [
    {
      target: '#btnExport',
      content: 'Exporte o XML com os resultados',
    },
  ],
  printTutorial: [
    {
      step: 1,
      title: 'Bem-vindo(a) à nova listagem de lotes',
      description:
        'Agora suas amostras ficam agrupadas em lotes, facilitando sua separação e possibilitando o rastreio. Conheça a nova tela!',
      layout: 'centered-template',
      image: '/static/images/aol-20-logo-no-text.svg',
      screenPosition: 5,
      cta: [
        {
          label: 'COMEÇAR',
          action: 'nextStep',
          color: 'white',
        },
      ],
      visible: false,
    },
    {
      step: 2,
      layout: 'centered-template',
      image: '/static/images/card-lote.svg',
      screenPosition: 5,
      cta: [
        {
          label: 'Anterior',
          action: 'previousStep',
          color: 'white',
        },
        {
          label: 'Próximo',
          action: 'nextStep',
          color: 'white',
        },
      ],
      visible: false,
    },
    {
      step: 3,
      title: 'Consulte as etiquetas já impressas',
      description: 'Lotes já impressos ficam organizados separadamente.',
      layout: 'centered-template',
      beforeStyles:
        'content: url(/static/images/arrow-left-tutorial.svg);position: absolute; left: 125px; top: -100px; display: block;',
      elementIdToHilight: 'batch-card-printed-0',
      arrowTarget: 'batch-card-printed-0',
      screenPosition: 5,
      cta: [
        {
          label: 'Anterior',
          action: 'previousStep',
          color: 'white',
        },
        {
          label: 'Próximo',
          action: 'nextStep',
          color: 'white',
        },
      ],
      visible: false,
    },
    {
      step: 4,
      title: 'Troque de abas',
      description:
        'As abas separam os lotes que são do AOL dos que foram gerados via integração direta. Ao lado do título da aba mostram quantos lotes há em cada categoria.',
      layout: 'centered-template',
      beforeStyles:
        'content: url(/static/images/arrow-top-tutorial.svg);position: absolute; left: 225px; top: 100px; display: block;',
      elementIdToHilight: 'fake-for-highlight',
      additionalStyles: [
        {
          style: 'background',
          value: 'white',
        },
        {
          style: 'position',
          value: 'relative',
        },
        {
          style: 'padding',
          value: '10px',
        },
      ],
      screenPosition: 8,
      cta: [
        {
          label: 'Anterior',
          action: 'previousStep',
          color: 'white',
        },
        {
          label: 'Próximo',
          action: 'nextStep',
          color: 'white',
        },
      ],
      visible: false,
    },
    {
      step: 5,
      title: 'Veja seus lotes e amostras',
      description:
        'Você pode ver todas as suas amostras mudando o modo de visualização de lotes para amostras.',
      layout: 'centered-template',
      elementIdToHilight: 'view-switcher',
      arrowTarget: 'view-switcher',
      beforeStyles:
        'content: url(/static/images/arrow-right-tutorial.svg);position: absolute; right: 225px; top: 0; display: block;',
      screenPosition: 5,
      additionalStyles: [
        {
          style: 'background',
          value: 'white',
        },
        {
          style: 'position',
          value: 'relative',
        },
        {
          style: 'padding',
          value: '15px 15px 15px 45px',
        },
        {
          style: 'border-radius',
          value: '5px',
        },
        {
          style: 'margin-left',
          value: '-80px',
        },
      ],
      cta: [
        {
          label: 'Anterior',
          action: 'previousStep',
          color: 'white',
        },
        {
          label: 'Próximo',
          action: 'nextStep',
          color: 'white',
        },
      ],
      visible: false,
    },
    {
      step: 6,
      title: 'Selecione os lotes que quer ver',
      description:
        'Os lotes da lista são todos do dia de hoje, mas você pode filtrar lotes e consultar amostras clicando no filtro ou na lupa.',
      layout: 'centered-template',
      elementIdToHilight: 'tutorial-highlight-subheader',
      beforeStyles:
        'content: url(/static/images/arrow-top1-tutorial.svg);position: absolute; left: 210px; top: 100px; display: block;',
      afterStyles:
        'content: url(/static/images/arrow-top2-tutorial.svg);position: absolute; right: 30px; top: 100px; display: block;',
      arrowTarget: 'tutorial-highlight-subheader',
      additionalStyles: [
        {
          style: 'background-color',
          value: 'white',
        },
        {
          style: 'background-image',
          value: 'url(/static/images/icon-back-to-search.svg)',
        },
        {
          style: 'background-repeat',
          value: 'no-repeat',
        },
        {
          style: 'background-position',
          value: '99% 50%',
        },
        {
          style: 'background-size',
          value: '25px',
        },
        {
          style: 'width',
          value: 'calc(100% - 80px)',
        },
        {
          style: 'position',
          value: 'relative',
        },
        {
          style: 'padding',
          value: '15px 0px 15px 20px',
        },
        {
          style: 'border-radius',
          value: '5px',
        },
      ],
      screenPosition: 8,
      cta: [
        {
          label: 'Anterior',
          action: 'previousStep',
          color: 'white',
        },
        {
          label: 'Concluir',
          action: 'preference',
          preference: 'newBatch',
          value: 'S',
          color: 'orange--invert',
        },
      ],
      visible: false,
    },
  ],
  defaultPreferences: [
    {
      userPreferenceLaboratoryId: null,
      userPreferenceId: 1,
      userPreferenceValueId: null,
      id: null,
      name: 'samplesOrderBy',
      description: 'Alterar a ordenação de listagem de amostras',
      value: null,
    },
    {
      userPreferenceLaboratoryId: null,
      userPreferenceId: 2,
      userPreferenceValueId: null,
      id: null,
      name: 'newBatch',
      description: 'Habilitar nova tela de lotes',
      value: null,
    },
    {
      userPreferenceLaboratoryId: null,
      userPreferenceId: 3,
      userPreferenceValueId: null,
      id: null,
      name: 'responsibleSignature',
      description: 'Habilitar a assinatura do médico responsável no XML de resultado',
      value: null,
    },
    {
      userPreferenceLaboratoryId: null,
      userPreferenceId: 4,
      userPreferenceValueId: null,
      id: null,
      name: 'dashboardDynamic',
      description: 'Habilitar novo dashboard',
      value: null,
    },
  ],
  frequentQuestions: [
    {
      id: 'serviceorders',
      category: 'Cadastro de Ordem de Serviço',
      linkcategory: 'Ordens de serviço',
      questions: [
        {
          id: 1,
          title: 'Como cadastrar uma Ordem de Serviço?',
          content:
            'Para cadastrar uma nova Ordem de Serviço, no menu lateral selecione a opção “Cadastrar Manualmente”, ou na página inicial na seção “Rotinas diárias” e  “Cadastrar Manualmente”.Informe os campos obrigatórios no cadastro do paciente, associe os exames ao paciente buscando por código do exame ou palavras-chave,  para finalizar o processo clique em “Salvar” e então será redirecionado para a Listagem de OS. Ou clique em “Salvar e cadastrar novo” para manter-se na página e cadastrar um novo paciente.',
        },
        {
          id: 2,
          title: 'Como importar um arquivo XML para cadastrar as Ordens de Serviço?',
          content:
            'Para cadastrar um volume maior de dados de uma só vez é possível utilizar a importação de XML (Para isso seu laboratório precisa configurar a exportação XML no formato Alvaro. Entre em contato com nosso 0800 643 8100 e solicite suporte). Primeiro exporte os dados de pacientes e ordens de serviço a partir do seu sistema LIS (laboratory information system) no formato XML, e então importe-o no AOL 2.0. Para importar o XML no sistema, basta clicar no menu lateral ”Importar arquivo XML” ou na página inicial no card "Rotinas diárias” e ”Importar arquivo XML".',
        },
      ],
    },
    {
      id: 'mandatorydocuments',
      category: 'Digitalização de documentos obrigatórios',
      linkcategory: 'Digitalização de documentos',
      questions: [
        {
          id: 3,
          title: 'Como inserir um documento obrigatório no AOL?',
          content:
            'Ao cadastrar uma Ordem de Serviço na tela de listagem de OS irá apresentar um botão “exames com documentos pendentes” informando a quantidade documentos pendentes, clique neste botão ou clique no ícone    disponível em cada linha de OS. Ao clicar neste botão irá apresentar a opção para “Baixar o documento”, faça isso para garantir que você terá sempre a última versão do documento. Após baixar, preencha e digitalize o documento e em seguida clique em “Anexar o documento digitalizado”.',
        },
        {
          id: 4,
          title: 'Como faço para confirmar se anexei os documentos obrigatórios no AOL?',
          content:
            'Após anexar o documento digitalizado, o ícone de anexo pendente irá mudar para “Documento anexado” clique neste botão e em seguida clique no ícone “Visualizar documento anexado” para confirmar se o documento está correto.',
        },
      ],
    },
    {
      id: 'allotmentsamples',
      category: 'Loteamento de amostras',
      linkcategory: 'Loteamento de amostras',
      questions: [
        {
          id: 5,
          title: 'Qual a importância de realizar o loteamento correto das amostras?',
          content:
            'Para garantir uma rastreabilidade de ponta a ponta é muito importante que as amostras sejam loteadas corretamente, ou seja, enviadas nas bags Alvaro Apoio devidamente identificadas. O sistema cria os lotes automaticamente, de acordo com o destino e acondicionamento. Cada lote possui um código de identificação e esse código é igual ao das amostras. Isso facilita a separação das amostras nas bags. Cada bag representa um Lote, portanto deve conter apenas uma etiqueta de Lote.',
        },
        {
          id: 6,
          title: 'Como verifico quais pacientes estão vinculados a um determinado lote?',
          content:
            'Para visualizar as amostras e pacientes agrupados em um lote, basta clicar no menu lateral “Impressão de Etiqueta”, ao identificar o lote que deseja clique na opção “Mostrar amostras” representado pelo desenho de olhinho, localizado no lado esquerdo do lote.Outra opção, ainda na tela “Impressão de Etiqueta”, é clicar na opção de visualização “Ver amostra” e clicar no código do lote (Ex: SAO.R.1) para ver os detalhes do lote, e em seguida clicar no botão “Visualizar Lote”. Assim você consegue acompanhar exatamente quais amostras devem ser alocadas em cada bag para realizar o loteamento.',
        },
        {
          id: 7,
          title: 'Como posso fechar um lote que ainda está em aberto?',
          content:
            'No menu lateral selecione a opção “Impressão de Etiqueta”. Para lotes de origem AOL, clique na opção “Imprimir etiquetas” e em seguida selecione a opção desejada: “Manter o lote aberto e imprimir etiquetas” ou “Fechar o lote e imprimir etiquetas”. O lote pode permanecer aberto até o fim da sua rotina, e quando estiver tudo pronto é só fechar o lote e realizar a impressão da etiqueta de lote para identificação da bag e envio à Logística. Para lotes de integração direta, basta clicar na opção “Fechar e imprimir lote” e seguir o mesmo processo de identificação da bag.',
        },
      ],
    },
    {
      id: 'traceability',
      category: 'Rastreabilidade em tempo real das amostras',
      linkcategory: 'Rastreabilidade de amostras',
      questions: [
        {
          id: 8,
          title: 'Como consultar o status de uma OS?',
          content:
            'Na página inicial no card de “Busca” informe a Ordem de Serviço do Alvaro Apoio, nome do Paciente ou Período específico para ter acesso às informações detalhadas das amostras.',
        },
        {
          id: 9,
          title: 'Como acompanhar onde minha amostra se encontra?',
          content:
            'Na seção  “Rastreabilidade - logística” a ferramenta disponibiliza um panorama geral de quantas amostras estão aguardando retirada e quantas já foram encaminhadas para o Núcleo Técnico Operacional(NTO) do Alvaro Apoio.Se a amostra rastreada estiver em trânsito, é possível visualizar o mapa com sua localização exata em tempo real.Já na seção “Rastreabilidade - produção” é possível acompanhar a quantidade de exames em triagem, em execução, quantos foram liberados e também os exames em atraso.',
        },
      ],
    },
    {
      id: 'answerpendency',
      category: 'Responder as pendências',
      linkcategory: 'Pendências',
      questions: [
        {
          id: 10,
          title: 'Como visualizar as pendências?',
          content:
            'Na página inicial é possível visualizar o alerta “Pendências” identificando a quantidade de itens a serem respondidos.Ao clicar no card você terá acesso a todas as pendências do seu laboratório.Para facilitar a gestão das pendências é possível ordenar por nome do paciente, status ou data da pendência.',
        },
        {
          id: 11,
          title: 'Onde visualizo as pendências que já foram resolvidas?',
          content:
            'Ao clicar no alerta “Pendências” disponível na página inicial, é possível visualizar uma lupa no canto superior direito da página, onde é possível filtrar por Período e também optar por visualizar as pendências que já foram resolvidas.',
        },
        {
          id: 12,
          title: 'Qual o prazo ideal para resolução de uma pendência?',
          content:
            'Com o objetivo de gerar o menor impacto possível na liberação do resultado de exames, o prazo ideal para resolução de uma pendência é de 48 horas.',
        },
        {
          id: 13,
          title: 'Qual a importância de responder às pendências?',
          content:
            'A gestão de pendências no sistema AOL2.0 é a forma mais rápida de comunicação entre a equipe técnica responsável pelos exames na Dasa e o Laboratório Apoiado.Quanto mais rápido as pendências forem solucionadas, menor será o impacto no prazo de liberação do resultado dos exames.',
        },
      ],
    },
    {
      id: 'paternityexam',
      category: 'Exame de Paternidade',
      linkcategory: 'Exame de Paternidade',
      questions: [
        {
          id: 14,
          title: 'Como solicitar acesso aos resultados de exames de Paternidade ?',
          content:
            'Na seção "Paternidade" no menu lateral selecione a opção "Não Possui Acesso".Nessa seção será possível preencher os dados do solicitante, tais como nome, CPF, RG, data de nascimento, sexo, nome da mãe, e - mail e celular e gerar formulário.',
        },
        {
          id: 15,
          title: 'Como acessar os resultados de exames de Paternidade ?',
          content:
            'Na seção "Paternidade" no menu lateral selecione a opção "Já Possui Acesso".Acesse com login e senha disponibilizado para acesso exclusivo aos resultados de exames de Paternidade.',
        },
      ],
    },
    {
      id: 'examcollectiondeadlines',
      category: 'Avisos de recoleta e alteração nos prazos dos exames',
      linkcategory: 'Recoleta e prazos de exames',
      questions: [
        {
          id: 16,
          title: 'Como visualizar os avisos de recoletas ?',
          content:
            'Na página inicial  é possível visualizar o alerta "Recoletas" identificando a quantidade de itens que necessitam recoleta.Ao clicar no card você terá acesso a todas as recoletas do seu laboratório.Para facilitar a gestão das recoletas é possível ordenar por data da recoleta ou OS Alvaro.',
        },
        {
          id: 17,
          title: 'Como gerar uma nova Ordem de Serviço de Recoleta ?',
          content:
            'Para gerar uma nova OS de recoleta, clique no botão “Recoletar”, o sistema irá gerar o cadastro do paciente e exames já preenchido, basta finalizar o cadastro clicando em “Salvar”. Após esse processo a recoleta mudará para o status “Aguardando transferência”, clique no botão “Ver cadastro” para transferir a OS.O status da recoleta mudará para “Realizado” Clique em “Ver amostra” e será direcionado para tela de impressão de etiqueta.',
        },
        {
          id: 18,
          title: 'Como visualizar as remarcações ?',
          content:
            'Na página inicial  é possível visualizar o alerta "Remarcação" identificando a quantidade de itens com remarcação.Ao clicar no card você terá acesso a todas as remarcações do seu laboratório, com detalhes do paciente, exame, motivo da remarcação e novo prazo.',
        },
      ],
    },
    {
      id: 'examresults',
      category: 'Resultado dos exames',
      linkcategory: 'Resultado dos exames',
      questions: [
        {
          id: 19,
          title: 'Como buscar os laudos que foram liberados?',
          content:
            'Para facilitar sua rotina, o Alvaro Apoio disponibiliza os resultados de exames em dois formatos: PDF e XML.Acesse o menu lateral e clique em “Resultados de Exames” ou na página inicial no card “Rastreabilidade - produção” é possível visualizar as opções Laudos em PDF” e “Resultados em XML”.',
        },
      ],
    },
  ],
  alerts: {
    alertSupplies:
      'Depois que o pedido de insumos é enviado para análise, <strong>não é possível fazer alterações ou cancelar</strong>. Para mais informações, entre em contato com o Executivo de Vendas responsável, ou obtenha suporte pelo telefone <strong>0800-643-8100</strong> opção 1.',
    alertSamples:
      '<strong>Impressão de etiquetas mudou!</strong> Acesse aqui as novas <a href="https://storageapoiob2bprd.blob.core.windows.net/aol-downloads/Apoio%20Novo%20Servi%C3%A7o%20Impressao.pdf" target="_blank">instruções</a> para configurar seu sistema.',
    alertRequiredDocs:
      '<strong style="color: #ff1a75;">Cliente Integração LIS</strong>, <a href="/documentos-obrigatorios">clique aqui</a> e acesse a nova tela para anexar suas pendências de documentos.',
  },
  statusColorBalls: {
    CANCELED_MATERIAL: {
      state: 'CANCELED_MATERIAL',
      color: '#b50000',
      message: 'Cancelado(s)',
    },
    SUSPENDED: { state: 'SUSPENDED', color: '#919191', message: 'Suspenso(s)' },
    RECOLLECT: { state: 'RECOLLECT', color: '#ff0000', message: 'Recoleta(s)' },
    PENDING_MATERIAL: {
      state: 'PENDING_MATERIAL',
      color: '#87003f',
      message: 'Amostra(s) Pendente(s)',
    },
    REGISTERED: { state: 'REGISTERED', color: '#ed6b75', message: 'Cadastrado(s)' },
    RUNNING: { state: 'RUNNING', color: '#f1c40f', message: 'Em Execução' },
    READY: { state: 'READY', color: '#659be0', message: 'Pronto(s)' },
    READED: {
      state: 'READED',
      color: '#3fc9d5',
      message: 'Exame(s) Liberado(s) e Lido(s)',
    },
  },
  examGuide: {
    HOUR: 'Hora(s)',
    DAY: 'Dia(s)',
  },
  resultsPDFErrorsMessages: {
    downloadFail:
      'Ops.. No momento não foi possível gerar o(s) laudo(s) selecionado. Pedimos que tente novamente em alguns minutos! Caso o problema persista, entre em contato via canais de suporte.',
  },
}
